export const userExternalAccountsQueryKeys = {
  all: ['user-external-accounts'] as const,
  list: (userId: string | undefined) =>
    [...userExternalAccountsQueryKeys.all, 'list', userId] as const,
  messageRateLimitCapacity: (userExternalAccountId: string | undefined) =>
    [
      ...userExternalAccountsQueryKeys.all,
      'message-rate-limit-capacity',
      userExternalAccountId,
    ] as const,
};
